/**
 * Created by Bart Decorte
 * Date: 2019-04-15
 * Time: 14:15
 */

export default class TableColumnSettingsCollection {

  constructor(data = []) {
    this.data = data;
  }

  set data(data) {
    this._data = data;
  }

  get data() {
    return this._data;
  }

  byName(name) {
    const match = this.data.filter(setting => setting.name == name);
    if (match.length) {
      return match[0];
    }
    return null;
  }

}


// WEBPACK FOOTER //
// ./resources/assets/js/helpers/TableColumnSettingsCollection.js